import React from 'react';
import { useParams } from 'react-router-dom';
import {
  PlmContract,
  usePlmContractDetailEditQuery,
  usePlmContractDetailEditSubSubscription,
} from '../../../../types/generated-types';
import { updateCacheFromSubscriptionEvent } from '../../../../helpers/subscriptionUtils';
import { PlmContractDetailForm } from './plmContract-detail-form';
import { useInjectableComponents } from '../../../system/services/injectableComponentsManager';
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';
import { Box, CircularProgress, Typography } from '@mui/material';

export const PlmContractEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { setTitle, setTitlePath } = useInjectableComponents();
  const isSmall = useIsSmallScreen();

  const { data, loading, error } = usePlmContractDetailEditQuery({
    variables: { id: id! },
    fetchPolicy: 'cache-and-network',
  });

  usePlmContractDetailEditSubSubscription({
    variables: { id: id! },
    fetchPolicy: 'no-cache',
    onData: updateCacheFromSubscriptionEvent,
  });

  React.useEffect(() => {
    setTitle(
      isSmall ? 'Edit PLM Contract' : 'Edit Peak Load Management Contract',
    );
    setTitlePath('/plmContracts');
    return () => {
      setTitle(undefined);
      setTitlePath(undefined);
    };
  }, [setTitle, setTitlePath, isSmall]);

  const plmContract = data?.plmContractById;

  if (loading) {
    return (
      <Box
        component="div"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <Box sx={{ marginBottom: '2rem' }}>
          <CircularProgress color="secondary" size="3rem" />
        </Box>
        <Box>
          <Typography variant="h4" color="secondary">
            Preparing your data...
          </Typography>
        </Box>
      </Box>
    );
  }
  return (
    <PlmContractDetailForm
      plmContract={plmContract}
      loading={loading}
      error={error}
    />
  );
};
